<div mat-dialog-title>Widget Details</div>

<div mat-dialog-content #target style="max-width: 98%">
  <form [formGroup]="addWidgetForm" *ngIf="dataSource.length > 1">
    <div class="left">
      <label>Widget Title<span class="requiredAsterix">*</span></label>
    </div>
    <div class="right">
      <mat-form-field style="margin-left: 5px; width: 98%" appearance="outline">
        <input
          matInput
          placeholder="Enter a title for the widget"
          name="buttonTitle"
          id="buttonTitle"
          maxlength="30"
          aria-label="Enter a title for the widget"
          formControlName="buttonTitle"
          required
          class="required"
        />
        <mat-error>This field is required</mat-error>
      </mat-form-field>
    </div>
  </form>

  <table
    mat-table
    [dataSource]="dataSource"
    style="width: 100%"
    cdkDropList
    [cdkDropListData]="dataSource"
    (cdkDropListDropped)="drop($event)"
    [cdkDropListDisabled]="dragDisabled"
  >
    >
    <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
      <th mat-header-cell *matHeaderCellDef>
        {{ col.label
        }}<span class="requiredAsterix" *ngIf="col.required">*</span>
      </th>
      <ng-container *matCellDef="let element; let i = index">
        <td mat-cell *ngIf="element.type == 'section'">
          <div [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'position'">
              <div
                class="example-handle"
                (mousedown)="dragDisabled = false"
                cdkDragHandle
              >
                <fa-icon
                  [icon]="faGripDotsVertical"
                  style="cursor: move"
                ></fa-icon>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'position'">
              <span class="sectionText">Section Header</span>
            </ng-container>
            <mat-form-field
              appearance="outline"
              class="form-input form-required"
              *ngSwitchCase="'title'"
              style="margin-bottom: 0; margin-left: 5px; width: 96%"
            >
              <input
                matInput
                [(ngModel)]="element[col.key]"
                placeholder="Enter a section header"
                aria-label="Enter a section header"
                name="title"
                id="title"
                maxlength="30"
                required
                class="required"
              />
              <mat-error>This field is required</mat-error>
            </mat-form-field>

            <div class="btn-edit" *ngSwitchCase="'isEdit'">
              <fa-icon
                [icon]="faTrash"
                style="cursor: pointer"
                (click)="removeRow(element.id)"
              ></fa-icon>
            </div>
          </div>
        </td>

        <td mat-cell *ngIf="element.type != 'section'">
          <div [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'position'">
              <div
                class="example-handle"
                (mousedown)="dragDisabled = false"
                cdkDragHandle
              >
                <fa-icon
                  [icon]="faGripDotsVertical"
                  style="cursor: move"
                ></fa-icon>
              </div>
            </ng-container>
            <mat-form-field
              appearance="outline"
              class="form-input"
              *ngSwitchCase="'title'"
              style="margin-bottom: 5px; margin-left: 5px; width: 97%"
            >
              <input
                matInput
                [(ngModel)]="element[col.key]"
                placeholder="Enter a title for this link"
                aria-label="Enter a title for this link"
                name="title"
                id="title"
                [maxlength]="titleLength"
                required
                class="required"
              />
              <mat-error>This field is required</mat-error>
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              *ngSwitchCase="'select'"
              style="margin-bottom: 5px; margin-left: 5px; width: 97%"
            >
              <mat-select
                [(ngModel)]="element[col.key]"
                placeholder="Please select the navigation destination"
                (selectionChange)="onChange($event, element)"
              >
                <mat-option value="Direct"> Direct Link </mat-option>
                <mat-option value="Platform"> Quantivate URL </mat-option>
                <mat-option value="Internal"> Internal Q Page </mat-option>
                <mat-option value="Workflow"> Workflows </mat-option>
                <mat-option value="Report"> Reports </mat-option>
              </mat-select>
            </mat-form-field>

            <ng-container *ngSwitchCase="'link'">
              <mat-form-field
                appearance="outline"
                class="form-input searchDropdown"
                *ngIf="element.linkType == 'Direct'"
              >
                <input
                  matInput
                  [(ngModel)]="element[col.key]"
                  placeholder="Enter a url for this link"
                  aria-label="Enter a url for this link"
                  required
                  class="required"
                />
                <mat-error>This field is required</mat-error>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="form-input searchDropdown"
                *ngIf="element.linkType == 'Platform'"
              >
                <input
                  matInput
                  [(ngModel)]="element[col.key]"
                  required
                  class="required"
                />
                <mat-error>This field is required</mat-error>
              </mat-form-field>

              <div
                class="searchDropdown"
                *ngIf="element.linkType == 'Workflow'"
              >
                <ng-select
                  placeholder="Please select a Workflow"
                  class="required"
                  [items]="workflows"
                  [clearable]="false"
                  [hideSelected]="true"
                  bindLabel="text"
                  bindValue="value"
                  groupBy="group"
                  appendTo="body"
                  [(ngModel)]="element.workflowId"
                  (change)="generateLink($event, element, i)"
                >
                </ng-select>
              </div>
              <div
                class="searchDropdown"
                *ngIf="element.linkType == 'Internal'"
              >
                <ng-select
                  placeholder="Please select a Item"
                  class="required"
                  [items]="internals"
                  [clearable]="false"
                  [hideSelected]="true"
                  bindLabel="text"
                  bindValue="url"
                  groupBy="group"
                  appendTo="body"
                  [(ngModel)]="element.internalId"
                  (change)="generateLink($event, element, i)"
                >
                </ng-select>
              </div>
              <div class="searchDropdown" *ngIf="element.linkType == 'Report'">
                <ng-select
                  placeholder="Please select a Report"
                  class="required"
                  [items]="records"
                  [clearable]="false"
                  [hideSelected]="true"
                  bindLabel="name"
                  bindValue="id"
                  appendTo="body"
                  [(ngModel)]="element.recordId"
                  (change)="generateLink($event, element, i)"
                >
                </ng-select>
              </div>
            </ng-container>
            <mat-form-field
              appearance="outline"
              style="margin-bottom: 5px; margin-left: 5px; width: 97%"
              class="form-input"
              *ngSwitchCase="'description'"
            >
              <input
                matInput
                [(ngModel)]="element[col.key]"
                maxlength="200"
                placeholder="Add help text to this link"
                aria-label="Add help text to this link"
              />
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <ng-container *ngSwitchCase="'position'">
              <span style="width: 100px">&nbsp;</span>
            </ng-container>
            <mat-form-field
              appearance="outline"
              class="form-input"
              *ngSwitchDefault
              style="margin-bottom: 0; margin-left: 5px; width: 97%"
            >
              <input
                matInput
                [(ngModel)]="element[col.key]"
                placeholder="{{ element[col.placeholder] }}"
              />
            </mat-form-field>
            <div class="btn-edit" *ngSwitchCase="'isEdit'">
              <fa-icon
                [icon]="faTrash"
                style="cursor: pointer"
                (click)="removeRow(element.id)"
              ></fa-icon>
            </div>
          </div>
        </td>
      </ng-container>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      cdkDrag
      [cdkDragData]="row"
    >
      >
    </tr>
  </table>

  <br />
</div>

<div mat-dialog-actions align="end">
  <button class="button-add-row button_small" mat-button (click)="addRow()">
    Add Link
  </button>
  <button class="button-add-row button_small" mat-button (click)="addSection()">
    Add Section
  </button>

  <span class="spacer" style="flex: 1 1 auto"></span>
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button
    mat-button
    class="button_small"
    id="addWidget"
    (click)="addWidget()"
    tabindex="-1"
    [disabled]="validateForm()"
  >
    {{ action }}
  </button>
</div>
